import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/women-world-cup-personal-summary/img/个人数据解析.png'


const _withScopeId = n => (_pushScopeId("data-v-77a385a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "containerBack" }, null, -1))
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bdTitle" }, "球队进攻", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bdTitle" }, "球队防守", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "bd",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewDetail('球队进攻')))
      }, _hoisted_6),
      _createElementVNode("div", {
        class: "bd",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewDetail('球队防守')))
      }, _hoisted_9)
    ])
  ]))
}